/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Components_Sandboxshell_Updated1Inputs */

const id_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diperbarui ${i?.date}`)
};

const ms_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dikemas Kini ${i?.date}`)
};

const da_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opdateret ${i?.date}`)
};

const de_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualisiert ${i?.date}`)
};

const en_us2_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.date}`)
};

const es_es2_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actualizado ${i?.date}`)
};

const es_mx2_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actualizado ${i?.date}`)
};

const fil_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Na-update ${i?.date}`)
};

const fr_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mis à jour ${i?.date}`)
};

const it_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiornato ${i?.date}`)
};

const hu_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frissítve: ${i?.date}`)
};

const nl_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bijgewerkt ${i?.date}`)
};

const no_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oppdatert ${i?.date}`)
};

const pl_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zaktualizowano ${i?.date}`)
};

const pt_br2_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.date}`)
};

const pt_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atualizado ${i?.date}`)
};

const ro_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actualizat ${i?.date}`)
};

const fi_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Päivitetty ${i?.date}`)
};

const sv_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uppdaterad ${i?.date}`)
};

const vi_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã cập nhật ${i?.date}`)
};

const tr_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} güncellendi`)
};

const cs_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualizováno ${i?.date}`)
};

const bg_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Актуализирано ${i?.date}`)
};

const ru_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обновлено ${i?.date}`)
};

const uk_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Оновлено ${i?.date}`)
};

const ar_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`آخر تحديث ${i?.date}`)
};

const hi_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} को अपडेट किया गया`)
};

const th_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`อัปเดตเมื่อ ${i?.date}`)
};

const ja_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} 更新`)
};

const zh_cn2_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.date}`)
};

const zh_hant1_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.date}`)
};

const ko_components_sandboxshell_updated1 = /** @type {(inputs: Components_Sandboxshell_Updated1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Updated {date}" |
*
* @param {Components_Sandboxshell_Updated1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_updated1 = /** @type {((inputs: Components_Sandboxshell_Updated1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Updated1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_updated1(inputs)
	if (locale === "ms") return ms_components_sandboxshell_updated1(inputs)
	if (locale === "da") return da_components_sandboxshell_updated1(inputs)
	if (locale === "de") return de_components_sandboxshell_updated1(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_updated1(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_updated1(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_updated1(inputs)
	if (locale === "fil") return fil_components_sandboxshell_updated1(inputs)
	if (locale === "fr") return fr_components_sandboxshell_updated1(inputs)
	if (locale === "it") return it_components_sandboxshell_updated1(inputs)
	if (locale === "hu") return hu_components_sandboxshell_updated1(inputs)
	if (locale === "nl") return nl_components_sandboxshell_updated1(inputs)
	if (locale === "no") return no_components_sandboxshell_updated1(inputs)
	if (locale === "pl") return pl_components_sandboxshell_updated1(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_updated1(inputs)
	if (locale === "pt") return pt_components_sandboxshell_updated1(inputs)
	if (locale === "ro") return ro_components_sandboxshell_updated1(inputs)
	if (locale === "fi") return fi_components_sandboxshell_updated1(inputs)
	if (locale === "sv") return sv_components_sandboxshell_updated1(inputs)
	if (locale === "vi") return vi_components_sandboxshell_updated1(inputs)
	if (locale === "tr") return tr_components_sandboxshell_updated1(inputs)
	if (locale === "cs") return cs_components_sandboxshell_updated1(inputs)
	if (locale === "bg") return bg_components_sandboxshell_updated1(inputs)
	if (locale === "ru") return ru_components_sandboxshell_updated1(inputs)
	if (locale === "uk") return uk_components_sandboxshell_updated1(inputs)
	if (locale === "ar") return ar_components_sandboxshell_updated1(inputs)
	if (locale === "hi") return hi_components_sandboxshell_updated1(inputs)
	if (locale === "th") return th_components_sandboxshell_updated1(inputs)
	if (locale === "ja") return ja_components_sandboxshell_updated1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_updated1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_updated1(inputs)
	return ko_components_sandboxshell_updated1(inputs)
});
export { components_sandboxshell_updated1 as "components.sandboxShell.updated" }